/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { ChangeEvent, FC, Fragment, useState } from 'react';
import { i18n } from '../../../../lib/i18n';
import { ECollapsedNotes } from '../../types';
import { TwoOpenNotes } from '../two-open-notes';
import { OneOpenNote } from '../one-open-note';

interface Props {
	initialPublicNote?: string;
	initialPrivateNote?: string;
	type: ECollapsedNotes;
	onOpen: (isPublic: boolean) => void;
	onChange: (publicNote?: string, privateNote?: string) => void;
}

export const CollapsedNotesLine: FC<Props> = ({ initialPublicNote, initialPrivateNote, type, onOpen, onChange }) => {
	const [publicNote, setPublicNote] = useState<string | undefined>(initialPublicNote);
	const [privateNote, setPrivateNote] = useState<string | undefined>(initialPrivateNote);
	const labels = i18n.addDiscount.content.custom.notes;

	const handleOpenPrivate = () => {
		onOpen(false);
	};

	const handlePublicNoteChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
		const note = e.target?.value;
		setPublicNote(note);
		handleOnChange(true, note);
	};

	const handlePrivateNoteChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
		const note = e.target?.value;
		setPrivateNote(note);
		handleOnChange(false, note);
	};

	const handleBothNoteChange = (e: ChangeEvent<HTMLTextAreaElement>, type: ECollapsedNotes) => {
		const isPublic = type === ECollapsedNotes.PUBLIC;
		if (isPublic) {
			handlePublicNoteChange(e);
		} else {
			handlePrivateNoteChange(e);
		}
	};

	const handleOnChange = (isPublic: boolean, note: string) => {
		if (isPublic) {
			onChange(note, privateNote);
		} else {
			onChange(publicNote, note);
		}
	};

	const onCancel = (isPublic: boolean) => {
		if (isPublic) {
			setPublicNote('');
			onChange('', privateNote);
		} else {
			setPrivateNote('');
			onChange(publicNote, '');
		}
	};

	return (
		<Fragment>
			{type === ECollapsedNotes.PUBLIC ? (
				<OneOpenNote
					labels={labels[ECollapsedNotes.PUBLIC]}
					onChange={handlePublicNoteChange}
					value={publicNote}
					onClick={handleOpenPrivate}
					onCancel={() => onCancel(true)}
				/>
			) : (
				<TwoOpenNotes
					publicValue={publicNote}
					privateValue={privateNote}
					isPublicFirst={true}
					labels={labels.both}
					onChange={handleBothNoteChange}
					onCancel={onCancel}
				/>
			)}
		</Fragment>
	);
};
